import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { AccountApi } from '@env0/account-service/api';
import type { CreateVcsProviderUserMapping, UpdateVcsProviderUserMapping } from 'types/api.types';

export default (client: HttpClient) => ({
  getVcsProviderUserMappings: () => {
    return client.get<AccountApi.VcsProviderUserMapping[]>(`users/me/vcs-provider-user-mappings`).then(returnData);
  },
  createVcsProviderUserMapping: (payload: CreateVcsProviderUserMapping) => {
    return client
      .post<AccountApi.VcsProviderUserMapping>(`users/me/vcs-provider-user-mappings`, payload)
      .then(returnData);
  },
  updateVcsProviderUserMapping: (payload: UpdateVcsProviderUserMapping) => {
    return client
      .put<AccountApi.VcsProviderUserMapping>(`vcs-provider-user-mappings/${payload.id}`, payload)
      .then(returnData);
  },
  getScimConfiguration: (organizationId: string) => {
    return client
      .get<AccountApi.Scim.GetScimConfiguration.Response>(`scim/configuration/${organizationId}`, {
        hideNotification: true
      })
      .then(returnData);
  },
  createScimConfiguration: (organizationId: string) => {
    return client
      .post<AccountApi.Scim.CreateScimConfiguration.Response>(`scim/configuration/${organizationId}`)
      .then(returnData);
  },
  deleteScimConfiguration: (organizationId: string) => {
    return client.delete(`scim/configuration/${organizationId}`);
  },
  getScimGroupMappings: (organizationId: string) => {
    return client
      .get<AccountApi.Scim.GetScimGroupMappings.Response>(`scim/group-team-mapping/${organizationId}`)
      .then(returnData);
  },
  deleteScimGroupMapping: (organizationId: string, mappingId: string) => {
    return client.delete(`scim/group-team-mapping/${organizationId}/${mappingId}`);
  },
  rotateScimConfiguration: (organizationId: string) => {
    return client
      .post<AccountApi.Scim.RotateScimToken.Response>(`scim/configuration/${organizationId}/rotate-token`)
      .then(returnData);
  }
});
